import { axiosPrivate, axiosPublic } from "../../api/axios";

const getUserFromLocalStorage = () => {
  try {
    const userData = localStorage.getItem("user");
    return userData ? JSON.parse(userData) : null;
  } catch (error) {
    return null;
  }
};

const clearLocalStorage = () => {
  try {
    localStorage.removeItem("user");
  } catch (error) {}
};

const login = async (user) => {
  const response = await axiosPublic.post(`/user/login`, user, {
    withCredentials: true,
  });

  clearLocalStorage();

  return response.data;
};

const logout = async () => {
  const response = await axiosPrivate.post(
    `/user/logout`,
    {},
    {
      withCredentials: true,
    },
  );

  clearLocalStorage();

  return response.data;
};

const validateUser = async (data) => {
  const response = await axiosPublic.post(`/user/validate-user`, data);
  return response.data;
};

const register = async (user) => {
  const formData = new FormData();

  Object.keys(user).forEach((key) => {
    if (key === "profile" && user[key] instanceof File) {
      formData.append("profile", user[key]);
    } else {
      formData.append(key, user[key]);
    }
  });

  const response = await axiosPublic.post(`/user/register`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

const verifyEmail = async (email) => {
  const response = await axiosPublic.post(`/otp/send-otp`, { email });
  return response.data;
};

const forgotPasswordToken = async (data) => {
  const response = await axiosPublic.post(`/user/forgot-password`, data);
  return response.data;
};

const resetPassword = async (data) => {
  const response = await axiosPublic.put(`/user/reset-password/${data.token}`, {
    password: data?.password,
  });
  return response.data;
};

const viewProfile = async () => {
  const response = await axiosPrivate.get(`/user/profile`, {
    withCredentials: true,
  });
  return response.data;
};

const toggleDarkMode = async (data) => {
  const response = await axiosPrivate.put(`/user/dark-mode`, data, {
    withCredentials: true,
  });
  return response.data;
};

const updateProfile = async (data) => {
  const response = await axiosPrivate.put(`/user/update-profile`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  });

  return response.data;
};

const updatePassword = async (data) => {
  const response = await axiosPrivate.put(`/user/update-password`, data);
  return response.data;
};

const refreshToken = async () => {
  const response = await axiosPublic.post(
    `/user/refresh-token`,
    {},
    {
      withCredentials: true,
    },
  );
  return response.data;
};

const checkUserBlock = async () => {
  try {
    const response = await axiosPrivate.get(`/user/check-block`);
    return response.data;
  } catch (error) {
    return { isBlocked: false, blockInfo: null };
  }
};

const authService = {
  login,
  logout,
  validateUser,
  register,
  verifyEmail,
  viewProfile,
  forgotPasswordToken,
  resetPassword,
  toggleDarkMode,
  updateProfile,
  updatePassword,
  refreshToken,
  getUserFromLocalStorage,
  clearLocalStorage,
  checkUserBlock,
};

export default authService;
